<template>
  <div class="raise-query-modal-wrapper">
    <div class="raise-query-modal-container" >
        <div class="titleclass d-flex justify-content-between py-2 px-3">
            <h4 class="my-0">{{ $t('navigations.raise query') }}</h4>
            <div class="close-link cursor-pointer" @click.prevent="closeModal()">
                <i class="fa fa-times" ></i>
            </div>
        </div> 
        <div class="raise-query-modal-body p-4">
            <div class="form-group row my-lg-2">
                <div class="col-lg-3 mb-1">
                <label class="col-form-label"
                    >{{ $t("navigations.site code") }}
                </label>
                <input
                    type="text"
                    class="form-control mb-1 my-lg-0"
                    v-model="siteCode"
                    disabled
                />
                </div>

                <div class="col-lg-3 mb-1">
                <label class="col-form-label"
                    >{{ $t("navigations.subject id") }}
                </label>
                <input
                    type="text"
                    class="form-control mb-1 my-lg-0"
                    v-model="subjectCode"
                    disabled
                />
                </div>

                <div class="col-lg-3 mb-1">
                <label class="col-form-label"
                    >{{ $t("navigations.visit name") }}
                </label>
                <input
                    type="text"
                    class="form-control mb-1 my-lg-0"
                    v-model="visitName"
                    disabled
                />
                </div>
                <div class="col-lg-12 mb-1">
                <label class="col-form-label">
                    {{ $t("navigations.query subject") }}
                    <sup><i class="fa fa-asterisk required"></i></sup>
                </label>
                <input type="text" class="form-control" maxlength="1000" v-model="values.Subject" />
                <span class="errorClass" v-if="errors[0]">
                    {{ $t("navigations.please enter query subject") }}</span
                >
                </div>

                <div class="col-lg-12 mb-1">
                <label class="col-form-label">
                    {{ $t("navigations.query message") }}
                    <sup><i class="fa fa-asterisk required"></i></sup>
                </label>
                <textarea
                    class="form-control mb-1 my-lg-0"
                    rows="4"
                    cols="150"
                    v-model="values.Message"
                >
                </textarea>
                <span class="errorClass" v-if="errors[1]">{{
                    $t("navigations.please enter query message")
                }}</span>
                </div>

                <div class="col-lg-4 mb-1">
                <label class="col-form-label">{{ $t("navigations.priority") }}</label>
                <select
                    class="form-control m-b"
                    name="account"
                    v-model="values.Priority"
                >
                    <option value="">{{ $t("navigations.low") }}</option>
                    <option value="Medium">{{ $t("navigations.medium") }}</option>
                    <option value="High">{{ $t("navigations.high") }}</option>
                </select>
                </div>
                <div class="col-lg-4 mb-1">
                <label class="col-form-label"
                    >{{ $t("navigations.role") }}
                    <sup><i class="fa fa-asterisk imp"></i></sup
                ></label>
                <Multiselect
                    @close="onroleClosed()"
                    @clear="closebtnclicked()"
                    v-model="multiRoleSelectList"
                    mode="multiple"
                    valueProp="roleID"
                    :placeholder="$t('navigations.select roles')"
                    label="roleName"
                    :options="roleList"
                    :hideSelected="false"
                    :closeOnSelect="false"
                    :searchable="true"
                    trackBy="roleName"
                    class="multiselect-theme"
                >
                    <template v-slot:option="{ option }">
                    {{ option.roleName }}
                    </template>
                </Multiselect>
                <span class="errorClass" v-if="errors[3]">{{
                    $t("navigations.please select role")
                }}</span>
                </div>
                <div class="col-lg-4 mb-1">
                <label class="col-form-label"
                    >{{ $t("navigations.recipients") }}
                    <sup><i class="fa fa-asterisk required"></i></sup>
                </label>

                <Multiselect
                    @close="onRecipientsClosed()"
                    @clear="recepientclosebtnclicked()"
                    v-model="values.Recipients"
                    mode="multiple"
                    valueProp="email"
                    :placeholder="$t('navigations.select recipients')"
                    label="recipients"
                    :options="recipients"
                    :hideSelected="false"
                    :closeOnSelect="false"
                    :searchable="true"
                    trackBy="email"
                    class="multiselect-theme"
                >
                    <template v-slot:option="{ option }">
                    {{ option.email }}
                    </template>
                </Multiselect>
                <span class="errorClass" v-if="errors[2]">{{
                    $t("navigations.please select recipient")
                }}</span>
                </div>

                <div class="col-lg-12 my-2 d-flex">
                    <div class="form-group">
                    <label>
                        <input
                        aria-expanded="true"
                        v-model="chksendmail"
                        aria-controls="collapseExample"
                        type="checkbox"
                        @click="check()"
                        />
                        {{ $t("navigations.send an email alert") }}
                    </label>
                    </div>
                    <div class="ibox" id="collapseOne" v-if="checkboxclick">
                    <table
                        class="
                        table table-striped table-bordered table-hover
                        dataTables-example
                        dataTable
                        "
                    >
                        <tbody>
                        <tr v-for="options in emailrecipients" :key="options.id">
                            <td>
                            <input
                                type="checkbox"
                                checked="checked"
                                :value="options.isChecked"
                                v-model="options.isChecked"
                                :id="options.id"
                            />
                            {{ options.evalu }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                <div class="col-lg-12 my-1 d-flex">
                <div class="col-lg-12 text-right">
                    <button
                    class="cancel_btn py-1 px-4 mx-3"
                    type="submit"
                    @click="ClearData()"
                    >
                    {{ $t("navigations.clear") }}
                    </button>
                    <button
                    class="save_btn py-1 px-4"
                    type="submit"
                    @click="CreateQuery()"
                    >
                    {{ $t("navigations.submit") }}
                    </button>
                </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template> 
  <script src="./raiseQueryModal.js"></script>
  <style scoped>
  @import "../../assets/savepages.css";
  .raise-query-modal-wrapper {
  position: fixed;
  display: flex;
  justify-content:center;
  align-items: center;
  inset: 0;
  background: rgb(0 0 0 / 30%);
  transition: cubic-bezier;
  overflow: hidden;
  z-index: 10000;
}

.raise-query-modal-container {
  width: min(900px, 90%);
  background: #fff;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;
}
  .multiselect-theme {
    --ms-option-bg-selected-pointed: rgb(210, 210, 210);
    --ms-option-bg-selected: rgb(210, 210, 210);
    --ms-option-color-selected: #000;
    --ms-option-color-selected-pointed: #000;
  }
  .form-control {
    height: auto !important;
  }
  
  
  </style>